export const isChrome = navigator.userAgent.indexOf("Chrome") != -1;
export const isSafari = !isChrome && navigator.userAgent.indexOf("Safari") != -1;
export const isFirefox = navigator.userAgent.indexOf("Firefox") != -1;

export function getChromeVersion() {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return raw ? parseInt(raw[2], 10) : false;
}

export function getSafariVersion() {
    if (isSafari) {
        return parseInt(navigator.userAgent.match(/Version\/([0-9]+)\./)[1]);
    } else {
        return false;
    }
}
